let googleMapsPromise: Promise<void> | null = null

export function useGoogleMapsLoader(): Promise<void> {
  if (!googleMapsPromise) {
    googleMapsPromise = new Promise<void>((resolve, reject) => {
      // If the new API is already loaded, resolve immediately
      if (typeof window.google?.maps?.importLibrary === 'function')
        return resolve()

      const apiKey = import.meta.env.VITE_GOOGLE_API_KEY

      if (!apiKey)
        return reject(new Error('VITE_GOOGLE_API_KEY is not set in .env file.'))

      // Create and inject the new Google Maps loader script
      const script = document.createElement('script')

      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&loading=async`
      script.async = true
      script.defer = true

      script.onload = () => {
        // Wait for the google object to be available
        const checkGoogleMaps = () => {
          if (typeof window.google?.maps?.importLibrary === 'function')
            resolve()
          else
            setTimeout(checkGoogleMaps, 50)
        }

        checkGoogleMaps()
      }

      script.onerror = error => {
        reject(new Error(`Failed to load Google Maps API ${error}`))
      }

      document.head.appendChild(script)
    })
  }

  return googleMapsPromise
}
